// DB module format
export interface DeviceControlModule {
  dataLossPrevention: DeviceControlRulesSection;
  dataLossPreventionExceptions: DeviceControlExclusionsSection;
}

export interface DeviceControlRulesSection {
  enable: boolean;
  rules: DeviceControlRuleItem[];
}

export interface DeviceControlExclusionsSection {
  enable: boolean;
  rules: DeviceControlExclusionRuleItem[];
}
export interface DiscoveredDeviceItem {
  _id: string;
  deviceName: string;
  deviceId: string;
  deviceClass: number;
  productId: number;
  endpointIds: string[];
  lastDetectionDate: string;
}

export interface DeviceControlExclusionRuleItem {
  exception: string;
  permission: DeviceControlPermissionType;
  ruleName: string;
  ruleType: DeviceControlExclusionsRuleType;
  userSID: string;
}
export interface DeviceControlExclusionRuleForm {
  type: DeviceControlExclusionsRuleType;
  exclusions: string[];
  description: string;
  permission: DeviceControlPermissionType;
}

export enum DeviceControlDeviceClassType {
  UNKNOWN = 0,
  BLUETOOTH = 1,
  CDROM_DRIVE = 2,
  DISK_DRIVE = 3,
  FLOPPY_DISK_DRIVE = 4,
  IEEE_1284_4 = 5,
  IEEE_1394 = 6,
  IMAGING = 7,
  MODEM = 8,
  NETWORK_ADAPTER = 9,
  TAPE_DRIVE = 10,
  USB = 11,
  WINDOWS_PORTABLE = 12,
  PORTS_COM_LPT = 13,
  SCSI_RAID = 14,
  STORAGE_VOLUME = 15,
  PRINTERS = 16,
  BITDEFENDER = 17,
  NETWORK_ADAPTER_WIRED = 18,
  NETWORK_ADAPTER_WIRELESS = 19,
  INTERNAL_STORAGE = 20,
  EXTERNAL_STORAGE = 21,
}
export enum DeviceControlExclusionsRuleType {
  PRODUCT = 1,
  DEVICE = 2,
}
export enum DeviceControlStatus {
  ALL = 0,
  ALLOWED = 1,
  BLOCKED = 2,
  RO = 3,
  CUSTOM = 4,
}

export enum DeviceControlDefaultRuleName {
  UNKNOWN = 'Unknown',
  BLUETOOTH = 'Bluetooth Devices',
  CDROM_DRIVE = 'CDROM Drives',
  DISK_DRIVE = 'Disk Drives',
  FLOPPY_DISK_DRIVE = 'Floppy Disk Drives',
  IEEE_1284_4 = 'IEEE 1284 4',
  IEEE_1394 = 'IEEE 1394',
  IMAGING = 'Imaging Devices',
  MODEM = 'Modems',
  NETWORK_ADAPTER = 'Network Adapter',
  TAPE_DRIVE = 'Tape Drives',
  USB = 'USB',
  WINDOWS_PORTABLE = 'Windows Portable',
  PORTS_COM_LPT = 'LPT/COM Ports',
  SCSI_RAID = 'SCSI Raid',
  STORAGE_VOLUME = 'Storage Volumes',
  PRINTERS = 'Printers',
  BITDEFENDER = 'Bitdefender',
  NETWORK_ADAPTER_WIRED = 'Network Adapters',
  NETWORK_ADAPTER_WIRELESS = 'Wireless Network Adapters',
  INTERNAL_STORAGE = 'Internal Storage',
  EXTERNAL_STORAGE = 'External Storage',
}

export enum DeviceControlPermissionType {
  ALLOWED = 1,
  BLOCKED = 2,
}

export interface DeviceControlRuleItem {
  deviceClass: DeviceControlDeviceClassType;
  productIds?: string[];
  deviceIds?: string[];
  permissions: DeviceControlPermissionsItem;
  ruleName: string;
}

export interface DeviceControlPermissionsItem {
  1394?: DeviceControlPermissionType;
  ALL: DeviceControlStatus;
  UNKNOWN?: DeviceControlPermissionType;
  IDE?: DeviceControlPermissionType;
  PCI?: DeviceControlPermissionType;
  PCMCIA?: DeviceControlPermissionType;
  USB?: DeviceControlPermissionType;
  SCSI?: DeviceControlPermissionType;
  SD?: DeviceControlPermissionType;
}
